
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/_modules/shared.module';
import { FileAttachmentComponent } from 'src/app/components/attachments/file-attachment/file-attachment.component';
import { PubmedAttachmentComponent } from 'src/app/components/attachments/pubmed-attachment/pubmed-attachment.component';

@Component({
    selector: 'app-modal-add-attachment',
    imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule,
    SharedModule,
    FileAttachmentComponent,
    PubmedAttachmentComponent
],
    templateUrl: './modal-add-attachment.component.html',
    styleUrls: ['./modal-add-attachment.component.scss'],
    standalone: true
})
export class ModalAddAttachmentComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalAddAttachmentComponent>, @Inject(MAT_DIALOG_DATA) public data: {}) { }

  attachmentData: any = {};

  ngOnInit(): void {

    if (this.data && Object.keys(this.data).length > 0) {
      this.attachmentData = JSON.parse(JSON.stringify(this.data));
    }
  }

  /**
   * Setto un elemento nella lista degli allegati
   * @param event
   */
  attachElement (evidence) {
    this.attachmentData.attachmentObject = evidence;
    this.dialogRef.close(this.attachmentData);
  }


  closeDialogue(event: any = null) {
    this.dialogRef.close({event:event});
  }
}
